import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="page-content" style={{ textAlign: 'center', padding: '6rem 1rem' }}>
      <div style={{ fontFamily: 'var(--font-display)', fontSize: '6rem', fontWeight: 700, color: 'var(--color-accent)', lineHeight: 1 }}>404</div>
      <h1 style={{ marginTop: '1rem', marginBottom: '0.75rem' }}>Page introuvable</h1>
      <p style={{ color: 'var(--color-text-muted)', fontSize: '1.05rem', marginBottom: '2.5rem' }}>
        Cette page n'existe pas ou a été déplacée.
      </p>
      <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link to="/" className="btn btn-primary btn-lg">Retour à l'accueil</Link>
        <Link to="/villes" className="btn btn-outline">Voir les villes</Link>
        <Link to="/accompagnement" className="btn btn-outline">Nous contacter</Link>
      </div>
    </div>
  );
}
